<template>
    <main class="main" id="main">
        <franchiseNav></franchiseNav>
        <div class="top_line">
            <div class="container">
                <h1>WHITE LABEL - ЗАРАБАТЫВАЙ! ПРОСТО ЗАРАБАТЫВАЙ!</h1>
            </div>
        </div>

        <!----------Section feed------------->

        <section class="section s-seo">
            <div class="container">
                <div class="seo_box">
                    <div class="item">
                        <h1>Сравним основные партнерские программы:</h1>
                        <p><strong>Франчайзинг</strong> – Вы платите взнос. Платите роялти.
                            Зависите от головного офиса.</p>
                        <p><strong>SaaS</strong> – Вы покупаете готовую платформу заплатив один раз и она
                            Ваш и только Ваша. Делаете с ней что угодно.</p>
                        <p><strong>White Label</strong> – Нет взноса. Нет роялти. Вы зарабатываете на своем ресурсе и посредственно
                            участвуете в работе. Комиссию от ресторанов мы делим 50/50. Эта модель сотрудничества является
                            минимальной в плане доходности, но проста в управлении, интеграции и требует вложений менее 100
                            долларов.</p>
                    </div>
                    <div class="item">
                        <h1>WHITE LABEL В ДОСТАВКЕ ЕДЫ от хочу-поесть.рф и WHEN-HUNGRY со знаком SMART</h1>
                        <p>У Вас уже есть какой-то сайт. Отлично. Он не обязательно должен быть о еде и продуктах.
                            Мы настроим на нем виджеты по доставке еды. Люди будут заказывать доставку еды через
                            Ваш сайт. Получайте свою комиссию каждый день от каждого заказа!</p>
                        <p>У Вас нет сайта? Ничего страшного! Мы за 3 дня создадим его для Вас и Вам останется только работать.
                            Делаем это или бесплатно или за $49в месяц. Пишите – обсудим именно Ваш случай.</p>
                    </div>
                    <div class="item">
                        <h1>ОСТАЛИСЬ ВОПРОСЫ? ОТВЕТИМ!</h1>
                        <p>Понимаем, разобраться со всем очень сложно. Но это современные способы
                            взаимодействия одних предпринимателей с другими. </p>
                        <p>Нам кажется, раз Вы находитесь на этой странице Вы хотите заниматься
                            серьезным бизнесом поэтому придется разобраться со всеми нюансами и тонкостями.
                            Мы Вам в этом поможем! </p>
                    </div>
                    <div class="item">
                        <p>Остались вопросы? Не можете разобраться, что выбрать и как начать зарабатывать на доставке еды? Напишите нам <span>reklama@hochu-poest.com</span> или в ICQ <span>333494862</span></p>
                        <p>Нам кажется, раз Вы находитесь на этой странице Вы хотите заниматься
                            серьезным бизнесом поэтому придется разобраться со всеми нюансами и тонкостями.
                            Мы Вам в этом поможем! </p>
                    </div>
                </div>

            </div>

        </section>
    </main>

</template>

<script>
import franchiseNav from '@/components/franchiseNav'
export default {
  name: 'wl',
  components: {franchiseNav}
}
</script>

<style scoped>
  h1 {
      font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/articles/wl.vue